import { createContext } from "react";

export const MarcasContext = createContext()
export const MarcasFormContext = createContext()
export const MarcasReportContext = createContext()